import anime from "animejs/lib/anime.es.js";

let animations = {};
const baseAnim = {
    timelines: []
};

animations.scaleToEnd = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Image scale down animation
    let image = el.querySelector(".band__wrapper");
    let imageAnim = anime.timeline({ autoplay: false, loop: true });
    let screenImage = el.querySelector(".band__imageDisplay");

    let bandHScale = window.innerHeight / screenImage.clientWidth;
    let bandWScale = window.innerWidth / screenImage.clientWidth;
    let scale = bandHScale > bandWScale ? bandHScale : bandWScale;

    anime.set(image, {
        scale: scale + 0.8 //.5 is a magic number fix
    });

    imageAnim.add({
        targets: image,
        duration: 1500,
        delay: 500,
        scale: 1,
        easing: "linear"
    });

    animConfig.timelines.push({
        start: 0,
        end: -0.75,
        timeline: imageAnim
    });

    // Title / text
    let content = el.querySelector(".band__content");
    let contentAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(content, {
        opacity: 0,
        scale: 0.7
    });

    contentAnim
        .add({
            targets: content,
            opacity: 1,
            scale: 0.7,
            translateY: 40,
            direction: "alternate",
            easing: "cubicBezier(0.6, 0.2, 0.1, 1)",
            duration: 1000
        })
        .add({
            targets: content,
            opacity: 0,
            delay: 500,
            duration: 1000,
            easing: "linear"
        });

    animConfig.timelines.push({
        start: 0.2,
        end: -1,
        timeline: contentAnim
    });

    return animConfig;
};

animations.wipeOut = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Widen out the frame animation
    let widenOutAnim = anime.timeline({ autoplay: false, loop: true });
    widenOutAnim.add({
        targets: el,
        easing: "linear",
        width: "100vw"
    });

    animConfig.timelines.push({
        start: 0.6,
        end: 0.3,
        timeline: widenOutAnim
    });

    // title enter animation
    let content = el.querySelector(".band__content");
    let contentAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(content, {
        opacity: 0,
        scale: 0.8
    });

    contentAnim
        .add({
            targets: content,
            opacity: 1,
            scale: 1,
            easing: "linear",
            duration: 500
        })
        .add({
            targets: content,
            opacity: 0,
            delay: 500,
            duration: 500,
            scale: 0.8,
            easing: "linear"
        });

    animConfig.timelines.push({
        start: 0.6,
        end: -0.3,
        timeline: contentAnim
    });

    return animConfig;
};

animations.blurIn = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Widen out the frame animation
    let animEl = el.querySelector(".band__wrapper");
    let blurAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(animEl, {
        scale: 1.3
    });

    blurAnim.add({
        easing: "linear",
        scale: 1,
        update: function(anim) {
            let blurVal = 5;
            let val = blurVal - (blurVal * anim.progress) / 100;
            animEl.style.filter = "blur(" + val + "px)";
        }
    });

    animConfig.timelines.push({
        start: 0.4,
        end: 0.1,
        timeline: blurAnim
    });

    return animConfig;
};

animations.fixedBackground = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // title enter animation
    let content = el.querySelector(".band__content");
    let contentAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(content, {
        opacity: 0
    });

    contentAnim
        .add({
            targets: content,
            opacity: 1,
            easing: "linear",
            duration: 500
        })
        .add({
            targets: content,
            duration: 550,
            opacity: 0,
            easing: "linear"
        });

    animConfig.timelines.push({
        start: 0.4,
        end: -0.5,
        timeline: contentAnim
    });

    return animConfig;
};

animations.wipeFromLeft = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    let wipeAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(el, {
        width: "0vw"
    });

    wipeAnim.add({
        targets: el,
        easing: "linear",
        width: "100vw"
    });

    animConfig.timelines.push({
        start: 0.5,
        end: 0.1,
        timeline: wipeAnim
    });

    return animConfig;
};

animations.slideFromLeft = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Widen out the frame animation
    let animEl = el.querySelector(".band__wrapper");
    let wipeAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(animEl, {
        translateX: "-100%"
    });

    wipeAnim.add({
        targets: animEl,
        easing: "linear",
        translateX: "0%"
    });

    animConfig.timelines.push({
        start: 0.5,
        end: 0.1,
        timeline: wipeAnim
    });

    return animConfig;
};

animations.slideFromRight = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Widen out the frame animation
    let animEl = el.querySelector(".band__wrapper");
    let wipeAnim = anime.timeline({ autoplay: false, loop: true });

    anime.set(animEl, {
        translateX: "100%"
    });

    wipeAnim.add({
        targets: animEl,
        easing: "linear",
        translateX: "0%"
    });

    animConfig.timelines.push({
        start: 0.5,
        end: 0.1,
        timeline: wipeAnim
    });

    return animConfig;
};

animations.fadeIn = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Widen out the frame animation
    let targetEl = el.querySelector(".band__wrapper");
    let fadeInAnim = anime.timeline({ autoplay: false, loop: false });

    anime.set(targetEl, {
        opacity: 0,
        scale: 1.3
    });

    fadeInAnim.add({
        targets: targetEl,
        easing: "linear",
        opacity: 1,
        scale: 1
    });

    animConfig.timelines.push({
        start: 0.8,
        end: 0.25,
        timeline: fadeInAnim
    });

    return animConfig;
};

animations.revealTitle = el => {
    let animConfig = Object.assign({}, baseAnim);
    animConfig.el = el;
    animConfig.timelines = [];

    // Widen out the frame animation
    let targetEl = el.querySelector(".band__content");
    let contentAnim = anime.timeline({ autoplay: false, loop: false });

    anime.set(targetEl, {
        opacity: 0,
        scale: 1.1,
        translateY: "10%"
    });

    contentAnim
        .add({
            targets: targetEl,
            easing: "linear",
            opacity: 1,
            scale: 1,
            translateY: "0",
            duration: 500
        })
        .add({
            targets: targetEl,
            easing: "linear",
            opacity: 0,
            scale: 1.1,
            translateY: "-10%",
            delay: 500,
            duration: 500
        });

    animConfig.timelines.push({
        start: 0.4,
        end: -0.4,
        timeline: contentAnim
    });

    return animConfig;
};

animations.titleReveal = el => {
    let animConfig = Object.assign({}, baseAnim);

    animConfig.el = el;
    animConfig.start = 0;
    animConfig.end = -0.25;
    animConfig.timeline = anime.timeline({ autoplay: false, loop: true });

    anime.set(el, {
        opacity: 0,
        translateY: 20,
        scale: 1.2
    });

    animConfig.timeline
        .add({
            targets: el,
            easing: "linear",
            duration: 250,
            // delay: 400,
            // endDelay: 750,
            opacity: 1,
            translateY: 0,
            scale: 1
        })
        .add({
            targets: el,
            easing: "linear",
            duration: 250,
            delay: 400,
            // endDelay: 500,
            opacity: 0,
            translateY: -20,
            scale: 1.2
        });

    return animConfig;
};

export default animations;
